export default __webpack_public_path__ + "static/newsletter-d56be93af49b3daef05b0b9e2c310ed1.png";